import { useQuery } from '@apollo/client';
import { Box, Text } from '@chakra-ui/react';
import React, { FC, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import AutocompleteSelect from '../../../../../components/Form/AutocompleteSelect';
import { GET_PAGES } from '../../../../../graphQL/queries';
import useAuth from '../../../../../hooks/useAuth';
import useDebounce from '../../../../../hooks/useDebounce';
import { PageType } from '../../../../MenuItem/types';
import NavSkeleton from '../../../../../components/Aside/NavSkeleton';

const NonEditablePages: FC = () => {
  const { formState, control } = useForm();

  const { data: pages } = useQuery(GET_PAGES, {
    variables: {
      limit: 0,
      page: 1,
    },
  });

  const { debounce } = useDebounce();

  const { updateNonEditablePages, nonEditablePages } = useAuth();

  // eslint-disable-next-line consistent-return
  const [nonEditablePagesOptions, setNonEditablePagesOptions] =
    useState<any[]>();

  // eslint-disable-next-line react-hooks/exhaustive-deps, consistent-return
  const getDefaultValues = () => {
    if (nonEditablePages) {
      const selectedPages = pages?.pagesPaginated?.data?.filter(
        (page: PageType) => nonEditablePages.includes(page.slug),
      );
      if (selectedPages?.length > 0) {
        const pagesToReturn = selectedPages?.map((page: any) => ({
          value: page.slug,
          label: page.name,
        }));

        setNonEditablePagesOptions(pagesToReturn);
        return pagesToReturn;
      }
    }
  };

  useEffect(() => {
    getDefaultValues();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pages]);
  const { t } = useTranslation();
  const { errors } = formState;
  return (
    <>
      {nonEditablePagesOptions ? (
        <Box
          mt={7}
          maxW="md"
          borderWidth="1px"
          borderRadius="lg"
          p={4}
          boxShadow="md"
        >
          <Text fontSize="xl" fontWeight="bold" mb={3}>
            {t('nonEditablePages')}
          </Text>
          <Text color="gray.600" fontSize="md" mb={6}>
            {t('selectNonEditablePages')}
          </Text>
          <AutocompleteSelect
            label="Páginas não editáveis"
            control={control}
            error={errors.stories}
            width="100%"
            isMulti
            defaultValue={
              nonEditablePagesOptions ?? [
                {
                  label: 'Home',
                  value: 'home',
                },
              ]
            }
            onChange={(value: any) => {
              debounce(() => {
                updateNonEditablePages(value?.map((item: any) => item.value));
              }, 300);
            }}
            // eslint-disable-next-line array-callback-return, consistent-return
            options={pages?.pagesPaginated?.data
              // eslint-disable-next-line array-callback-return, consistent-return
              .map((page: any) => {
                if (page.slug !== 'home') {
                  return {
                    value: page.slug,
                    label: page.name,
                  };
                }
              })
              .filter((item: any) => item !== undefined)}
            name="non-editable-pages"
          />
        </Box>
      ) : (
        <NavSkeleton />
      )}
    </>
  );
};

export default NonEditablePages;
